<template>
    <div>
        <transition name="slide-down">
            <section
                id="timer-top-banner"
                class="timer-top-banner sales-button-active timer-top-banner--no-timer"
                :class="`timer-top-banner--${product.progress_tracking_slug}`"
                v-show="salesButtonSeen">
                <div
                    class="timer-top-banner__inner timer-top-banner__inner--no-timer"
                    :class="{ 'long-price': longPrice }">
                    <div>
                        <p
                            v-if="!removeOriginalPrice"
                            class="timer-top-banner__title timer-top-banner__title--normally"
                            :class="{ 'long-price': longPrice }">
                            {{ $t('sales.normally') }}
                            <span class="striketrought striketrought--gray">{{ originalPrice }}</span>
                        </p>
                        <p
                            v-if="removeOriginalPrice"
                            class="timer-top-banner__title timer-top-banner__title--full"
                            :class="{ 'long-price': longPrice }">
                            {{ $t('sales.only') }} {{ fullPrice }}
                        </p>
                        <p
                            v-else
                            class="timer-top-banner__title timer-top-banner__title--full"
                            :class="{ 'long-price': longPrice }">
                            {{ $t('sales.nowOnly') }} {{ fullPrice }}
                        </p>
                    </div>

                    <div class="timer-top-banner__button-wrapper sales-button-active">
                        <open-checkout-popup v-if="defaultPaymentMethod === 'null'">
                            <div class="timer-top-banner__button sales-button-active">
                                {{ $t('sales.signUp') }}
                            </div>
                        </open-checkout-popup>
                        <div
                            v-else
                            class="timer-top-banner__button sales-button-active"
                            @click.prevent="scrollToPaymentBlock">
                            {{ $t('sales.signUp') }}
                        </div>
                    </div>
                </div>
                <div @click="hideTimerBanner" class="timer-top-banner__close">&times;</div>
            </section>
        </transition>
        <div id="timer-top-banner-spacer" class="timer-top-banner-spacer--no-timer" v-show="salesButtonSeen"></div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { fixedTopBarMixin } from '../mixins/fixedTopBarMixin';
import { iosview } from '../iosview';

export default {
    mixins: [fixedTopBarMixin],
    data: function () {
        return {
            longPrice: false,
            scrollToClass: '.product-price__plan-price',
            timerTopBar: false,
            noThanksLinkElement: null,
        };
    },
    computed: {
        ...mapState(['removeOriginalPrice', 'enforceHardDisplay', 'isUpsell']),
        ...mapGetters(['product']),
        originalPrice() {
            if (window.App.isIosView) {
                if (this.product.price.iosview?.oldPrice) {
                    return this.getIosviewDisplayValue('oldPrice');
                }
            }
            return this.product.price.original
                ? this.product.price.full.display_value[this.enforceHardDisplay ? 'hard' : 'soft']
                : null;
        },
        fullPrice() {
            if (window.App.isIosView) {
                if (this.product.price.iosview?.newPrice) {
                    return this.getIosviewDisplayValue('newPrice');
                }
            }
            return this.product.price.full
                ? this.product.price.full.display_value[this.enforceHardDisplay ? 'hard' : 'soft']
                : null;
        },
    },
    watch: {
        originalPrice: function () {
            if (this.fullPrice !== null && this.fullPrice.length > 5) {
                this.longPrice = true;
            }
        },
        facebookHackActivated: function () {
            if (this.facebookHackActivated) {
                this.scrollToClass = '.product-price';
            } else {
                this.scrollToClass = '.product-price__plan-price';
            }
        },
    },
    methods: {
        getIosviewDisplayValue(iosviewPriceField) {
            // format numbers with decimal parts to 2 decimal places
            const hasDecimalPart = this.product.price.iosview[iosviewPriceField].price % 1 !== 0;
            return (
                this.product.price.iosview.currencySymbol +
                this.product.price.iosview[iosviewPriceField].price.toLocaleString(undefined, {
                    minimumFractionDigits: hasDecimalPart ? 2 : 0,
                }) +
                this.product.price.iosview.currency
            );
        },
    },
    mounted() {
        // skip button click listener
        this.$nextTick(() => {
            if (!this.noThanksLinkElement && this.isUpsell) {
                this.noThanksLinkElement = document.querySelector('.no_thanks_btn');
                document.addEventListener('click', (e) => {
                    if (e.target.matches('.no_thanks_btn')) {
                        iosview.skipButtonClicked();
                    }
                });
            }
        });
    },
};
</script>
